import { FC, ReactNode } from 'react';
import { Box, Button, Heading, Icon } from '@chakra-ui/react';
import { IconType } from 'react-icons';
import { BiArrowBack, BiBlock } from 'react-icons/bi';
import { Link } from 'react-router-dom';

type Props = {
  title: string;
  subtitle: ReactNode;
  icon?: IconType;
};

export const ObjectNotFound: FC<Props> = ({
  title,
  subtitle,
  icon = BiBlock,
}) => {
  return (
    <Box maxW="50%" textAlign="center">
      <Icon as={icon} mb={4} fontSize="5xl" color="gray.300" />
      <Heading size="lg" data-testid="title">
        {title}
      </Heading>
      <Box mt={8} fontSize="lg" color="gray.600" data-testid="subtitle">
        {subtitle}
      </Box>
      <Button
        as={Link}
        to="/"
        mt={12}
        leftIcon={<Icon as={BiArrowBack} />}
        variant="outline"
      >
        Back to homepage
      </Button>
    </Box>
  );
};
